import { useChatContext } from '@components/Chat/ChatContextProvider/ChatContextProvider';

export const useDisableFocusTrapWithChatProps = () => {
	const { showChat } = useChatContext();

	return {
		disableEnforceFocus: !!showChat, // Disable focus trap enforcement when chat is shown
	};
};
